import { alpha, createTheme, lighten } from "@mui/material/styles";
import { EnergyGainTheme, themeColors } from "./EnergyGainTheme";

const colors = {
  shadows: {
    card: "0px 9px 16px rgba(0, 0, 0, 0.18), 0px 2px 2px rgba(50, 50, 50, 0.32)", // Darker card shadows
    cardLg: "0 5rem 14rem 0 rgba(0, 0, 0, 0.7), 0 0.8rem 2.3rem rgba(0, 0, 0, 0.8), 0 0.2rem 0.3rem rgba(0, 0, 0, 0.6)",
  },
  stackChart: {
    energy: {
      grid: "rgb(46, 150, 255)", // brightish blue
      solar: "rgb(2, 178, 175)", // turquoise
      export: "#fffbe8",
    },
    cost: {
      grid: "#FF8C00",
      solar: "#FFD700",
      export: "#fffbe8",
    },
  },
};

export const EnergyGainDarkTheme = createTheme({
  ...EnergyGainTheme, // shallow-merge as your baseline
  colors: {
    ...EnergyGainTheme.colors,
    stackChart: {
      energy: {
        grid: colors.stackChart.energy.grid,
        solar: colors.stackChart.energy.solar,
        export: colors.stackChart.energy.export,
      },
      cost: {
        grid: colors.stackChart.cost.grid,
        solar: colors.stackChart.cost.solar,
        export: colors.stackChart.cost.export,
      },
    },
  },
  palette: {
    ...EnergyGainTheme.palette, // start with all the same palette
    mode: "dark",
    background: {
      default: lighten(themeColors.black, 0.07),
      paper: themeColors.blackLighter,
    },
    text: {
      primary: themeColors.white,
      secondary: themeColors.light,
    },
  },
  components: {
    ...EnergyGainTheme.components,
    MuiTypography: {
      styleOverrides: {
        caption: ({ theme }) => ({
          color: theme.palette.text.secondary,
        }),
        subtitle1: ({ theme }) => ({
          color: theme.palette.text.secondary,
        }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        ...EnergyGainTheme.components?.MuiPaper?.styleOverrides,
        elevation: {
          boxShadow: colors.shadows.card,
        },
        elevation24: {
          boxShadow: colors.shadows.cardLg,
          background: lighten(themeColors.black, 0.1),
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
          backgroundColor: lighten(themeColors.black, 0.15),
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: lighten(themeColors.black, 0.25),
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },
          "& .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: lighten(themeColors.black, 0.08),
          },
        },
        cell: {
          display: "flex",
          alignItems: "center",
          minHeight: "3rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          "& .MuiInputAdornment-root .MuiSvgIcon-root": {
            color: theme.palette.text.primary,
          },
          "&:hover fieldset": {
            borderColor: theme.palette.text.primary,
          },
          "&.Mui-focused fieldset": {
            borderColor: theme.palette.primary.main,
          },
        }),
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: "0",
          transition: "all 0.2s ease-in-out",
          color: themeColors.white + "!important",
          "&:hover, &:active, &.active, &.Mui-selected": {
            background: alpha(themeColors.black, 0.4) + "!important",
          },
          "&.Mui-selected:hover": {
            color: "#1565c0 !important",
            background: alpha(themeColors.black, 0.4) + " !important",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        ...EnergyGainTheme.components?.MuiAutocomplete?.styleOverrides,
        listbox: {
          backgroundColor: lighten(themeColors.black, 0.18),
          "& .MuiAutocomplete-option": {
            color: "white !important",
            transition: "background-color 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: alpha(themeColors.black, 0.4) + "!important",
            },
            "&.Mui-focused": {
              backgroundColor: alpha(themeColors.black, 0.4) + "!important",
            },
            "&.Mui-selected": {
              backgroundColor: alpha(themeColors.black, 0.4) + "!important",
            },
          },
        },
        popupIndicator: {
          color: "white !important",
        },
      },
    },
  },
});
